export class MessageCopyMoveFindReplaceDto {
  public Find: string;
  public Replace: string;

  constructor(init: any) {
    this.Find = init.Find;
    this.Replace = init.Replace;
  }
}
